import { Link } from 'react-router-dom';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { Seo } from '../components/Seo';
import { LEGAL_CONTACT_EMAIL, LEGAL_ORG_NAME } from '../lib/legal-site-info';

export function OrderTermsPage() {
  return (
    <>
      <Seo
        path="/bestelvoorwaarden"
        title="Bestelvoorwaarden"
        description={`Bestel- en leveringsvoorwaarden voor digitale ComfortTool™-producten (${LEGAL_ORG_NAME}): online betalen, account en herroeping.`}
        keywords="ComfortTool bestellen, bestelvoorwaarden, digitale levering, rapport"
      />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:py-14">
        <Breadcrumbs items={[{ label: 'Home', to: '/' }, { label: 'Bestelvoorwaarden' }]} />
        <article className="mt-6">
          <h1 className="text-3xl font-bold text-ct-text">Bestelvoorwaarden (concept)</h1>
          <p className="mt-2 text-sm text-ct-muted">{LEGAL_ORG_NAME} — digitale producten</p>
          <div className="mt-8 space-y-6 text-sm leading-relaxed text-ct-muted">
            <section>
              <h2 className="text-lg font-bold text-ct-text">1. Aanbod</h2>
              <p className="mt-2">
                Op de site en tijdens het bestellen zie je welke digitale bundels (zoals Comfort Basis en Comfort Plus)
                worden aangeboden. Het definitieve aanbod en de prijs zie je op de betaalpagina vóór je betaalt.
              </p>
            </section>
            <section>
              <h2 className="text-lg font-bold text-ct-text">2. Betaling</h2>
              <p className="mt-2">
                Betaling verloopt via een erkende online betaaldienst. Je ontvangt een bevestiging volgens de afspraken
                van die partij.
              </p>
            </section>
            <section>
              <h2 className="text-lg font-bold text-ct-text">3. Levering</h2>
              <p className="mt-2">
                Digitale producten worden beschikbaar gesteld in je account (rapport genereren, downloads waar
                van toepassing). Geen fysieke levering tenzij expliciet anders vermeld.
              </p>
            </section>
            <section>
              <h2 className="text-lg font-bold text-ct-text">4. Herroeping</h2>
              <p className="mt-2">
                Voor digitale diensten die met instemming direct worden uitgevoerd, kan het herroepingsrecht
                beperkt zijn. Bij twijfel: neem contact op vóór bestelling of binnen redelijke termijn bij problemen.
              </p>
            </section>
            <section>
              <h2 className="text-lg font-bold text-ct-text">5. Klachten</h2>
              <p className="mt-2">
                Meld technische of inhoudelijke problemen via{' '}
                <Link to="/contact" className="font-medium text-ct-accent hover:underline">
                  contact
                </Link>
                {LEGAL_CONTACT_EMAIL ? (
                  <>
                    {' '}
                    of{' '}
                    <a href={`mailto:${LEGAL_CONTACT_EMAIL}`} className="font-medium text-ct-accent hover:underline">
                      {LEGAL_CONTACT_EMAIL}
                    </a>
                  </>
                ) : null}
                .
              </p>
            </section>
            <p className="text-xs text-ct-muted/80">
              Aanvullend gelden de{' '}
              <Link to="/voorwaarden" className="text-ct-accent hover:underline">
                algemene voorwaarden
              </Link>{' '}
              en de{' '}
              <Link to="/disclaimer" className="text-ct-accent hover:underline">
                disclaimer
              </Link>
              .
            </p>
          </div>
        </article>
      </div>
    </>
  );
}
